export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};

/**
 * @deprecated
 * These exports have moved. Import them from `@qmulus/ui/utils/common.ts` instead.
 */
export {
  isDefined,
  isNullish,
  nullishToNull,
  nullishToUndefined,
} from '@qmulus/ui/utils/common.ts';

export function isPlainObject(value: unknown): value is Record<string, unknown> {
  return (
    Object.prototype.toString.call(value) === '[object Object]'
  );
}
